import React from "react";
import { Skeleton, Table } from "antd";
import { SettingOutlined, CalendarOutlined, UserOutlined, CheckCircleOutlined, StarOutlined } from "@ant-design/icons";
import "../../AdminBookingConfig.scss";
import "./AdminBookingConfigSkeleton.scss";

/**
 * Skeleton Loader Component for Admin Booking Configuration
 * Displays loading state with skeleton placeholders matching the exact design
 */
const AdminBookingConfigSkeleton = () => {
  return (
    <div className="admin-booking-config-page">
      <div className="admin-booking-config">
        <div className="admin-booking-config-header">
          <h2>
            <SettingOutlined />
            <Skeleton.Input active size="default" className="skeleton-title-text" />
          </h2>
          <div className="admin-booking-config-subtitle">
            <Skeleton.Input active size="default" className="skeleton-subtitle-text" />
          </div>
        </div>

        <div className="admin-booking-config-content">
          {/* Round Robin Skeleton */}
          <div className="admin-booking-config-round-robin">
            <div className="round-robin-label">
              <label htmlFor="round-robin-toggle">
                <CalendarOutlined style={{ marginRight: 8, color: "#52c41a", fontSize: 18 }} />
                <Skeleton.Input active size="default" className="skeleton-label-text" />
              </label>
              <div className="round-robin-description">
                <Skeleton.Input active size="default" className="skeleton-description-text" />
              </div>
            </div>
            <Skeleton.Button active size="default" className="skeleton-switch" />
          </div>

          {/* Table Skeleton */}
          <div className="admin-booking-config-table">
            <Table
              columns={[
                {
                  title: (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <UserOutlined style={{ marginRight: 10, color: "#52c41a", fontSize: 16 }} />
                      Admin Name
                    </span>
                  ),
                  width: 220,
                },
                {
                  title: (
                    <span>
                      <CheckCircleOutlined style={{ marginRight: 8, color: "#52c41a" }} />
                      Active
                    </span>
                  ),
                  width: 160,
                  align: "center",
                },
                {
                  title: (
                    <span>
                      <StarOutlined style={{ marginRight: 8, color: "#faad14" }} />
                      High Priority
                    </span>
                  ),
                  width: 160,
                  align: "center",
                },
                {
                  title: (
                    <span>
                      <CalendarOutlined style={{ marginRight: 8, color: "#1890ff" }} />
                      Max Daily Limit
                    </span>
                  ),
                  width: 200,
                  align: "center",
                },
              ]}
              dataSource={[1, 2, 3]}
              pagination={false}
              rowKey={(record) => record}
              components={{
                body: {
                  row: () => (
                    <tr>
                      <td>
                        <div style={{ 
                          display: "flex", 
                          alignItems: "center", 
                          gap: 10
                        }}>
                          <Skeleton.Avatar 
                            active 
                            size={36} 
                            shape="circle" 
                            style={{ flexShrink: 0 }}
                          />
                          <Skeleton.Input active size="small" className="skeleton-name-text" />
                        </div>
                      </td>
                      <td>
                        <div style={{ 
                          display: "flex", 
                          alignItems: "center", 
                          justifyContent: "center", 
                          gap: 8,
                          width: "100%",
                          minHeight: "32px"
                        }}>
                          <div style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            justifyContent: "center",
                            width: "44px",
                            flexShrink: 0
                          }}>
                            <Skeleton.Button active size="small" className="skeleton-switch-small" />
                          </div>
                          <div style={{ 
                            minWidth: "70px",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center"
                          }}>
                            <Skeleton.Input active size="small" className="skeleton-tag" />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div style={{ 
                          display: "flex", 
                          alignItems: "center", 
                          justifyContent: "center", 
                          gap: 8,
                          width: "100%",
                          minHeight: "32px"
                        }}>
                          <div style={{ 
                            display: "flex", 
                            alignItems: "center", 
                            justifyContent: "center",
                            width: "44px",
                            flexShrink: 0
                          }}>
                            <Skeleton.Button active size="small" className="skeleton-switch-small" />
                          </div>
                          <div style={{ 
                            minWidth: "70px",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center"
                          }}>
                            <Skeleton.Input active size="small" className="skeleton-tag" />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div style={{ 
                          display: "flex", 
                          alignItems: "center", 
                          justifyContent: "center", 
                          gap: 8,
                          width: "100%",
                          minHeight: "32px"
                        }}>
                          <Skeleton.Input 
                            active 
                            size="small" 
                            className="skeleton-input-number"
                          />
                          <Skeleton.Input 
                            active 
                            size="small" 
                            className="skeleton-per-day"
                          />
                        </div>
                      </td>
                    </tr>
                  ),
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminBookingConfigSkeleton;
